import { useContext, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import DeviceForm from "components/devices/DeviceForm";
import {
  createAlertDevice,
  createDevice,
  createDeviceAction,
  createDeviceVariable,
  updateDevice,
} from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";
import { listActions } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const DeviceCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const device = {
    companyID: me.companyID ?? "",
    branchID: "",
    name: "",
    location: "",
    brand: "",
    description: "",
    energyCost: null,
    currency: "",
    autoRefreshTime: 35,
    alerts: [],
    env: "dev",
  };

  async function onSubmit(values) {
    try {
      const {
        companyID,
        branchID,
        name,
        location,
        brand,
        description,
        variables,
        actions,
        alerts,
        coordsLat,
        coordsLng,
        timezone,
        energyCost,
        currency,
        autoRefreshTime,
        env,
      } = values;

      setLoading(true);

      const device = (
        await API.graphql({
          query: createDevice.replaceAll("__typename", ""),
          variables: {
            input: {
              companyID,
              branchID,
              name,
              location,
              brand,
              description,
              coordsLat,
              coordsLng,
              timezone,
              energyCost,
              currency,
              autoRefreshTime,
              env,
            },
          },
        })
      )?.data?.createDevice;

      const promises = [];

      promises.push(
        ...variables?.map((variable) =>
          API.graphql({
            query: createDeviceVariable.replaceAll("__typename", ""),
            variables: {
              input: {
                deviceID: device.id,
                ...variable,
              },
            },
          })
        )
      );

      promises.push(
        ...actions?.map((action) =>
          API.graphql({
            query: createDeviceAction.replaceAll("__typename", ""),
            variables: {
              input: {
                deviceID: device.id,
                ...action,
              },
            },
          })
        )
      );

      promises.push(
        ...alerts?.map((alert) =>
          API.graphql({
            query: createAlertDevice.replaceAll("__typename", ""),
            variables: {
              input: {
                deviceId: device.id,
                alertId: alert.id,
              },
            },
          })
        )
      );

      await Promise.all(promises);

      if (actions?.length > 0) {
        const actionsData = await API.graphql(
          graphqlOperation(listActions, {
            filter: {
              or: actions.map((act) => ({ id: { eq: act.actionID } })),
            },
          })
        );
        const actionsItems = actionsData.data.listActions.items ?? [];
        const actionsObj = {};
        actionsItems.forEach((actIt) => {
          const val = actIt.values && JSON.parse(actIt.values)?.[0]?.value;
          if (val) actionsObj[actIt.shortName] = val;
        });

        await API.graphql({
          query: updateDevice.replaceAll("__typename", ""),
          variables: {
            input: {
              id: device.id,
              actionsObj: JSON.stringify(actionsObj),
            },
          },
        });
      }

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/devices");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <DeviceForm onSubmit={onSubmit} initialValues={device} />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Dispositivo",
    successAdded: "Dispositivo agregado con éxito",
    responses: {},
  },
});

export default DeviceCreateForm;
